import { isEmpty } from 'lodash'
import React from 'react'

import Field, {
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import ReadonlyInput from '../../../../../../../1stlog-ui/src/components/Input/ReadonlyInput'

type TRoutingInformationProps = { readonly?: boolean }

const RoutingInformation = (
  props: TRoutingInformationProps,
): React.ReactElement => {
  const { readonly } = props

  const routingInformationText = useField('routingInformationText')

  const label = i18n.t('routing_information', 'Routinghinweis')

  return (
    <>
      {readonly && !isEmpty(routingInformationText) && (
        <div className="text-center">
          <Field name="routingInformationText" label={label}>
            <ReadonlyInput bigger />
          </Field>
        </div>
      )}
      <div hidden={readonly}>
        <Field name="routingInformationText" label={label}>
          <Input />
        </Field>
      </div>
    </>
  )
}

export default RoutingInformation
